<div class="badge-ccontainer">
  <div class="three-badge-row">
    <div class="city-badge">
      <img
        src="/assets/img/static-pages/medigi/v2-images/cities/orlando-icon.svg"
        alt="orlando"
      />
      <p class="city-name mb-0">Orlando, FL</p>
    </div>
    <div class="city-badge">
      <img
        src="/assets/img/static-pages/medigi/v2-images/cities/houston-icon.svg"
        alt="houston"
      />
      <p class="city-name mb-0">Houston, TX</p>
    </div>
    <div class="city-badge">
      <img
        src="/assets/img/static-pages/medigi/v2-images/cities/seattle-icon.svg"
        alt="seattle"
      />
      <p class="city-name mb-0">Seattle, WA</p>
    </div>
  </div>
  <div class="two-badge-row">
    <div class="city-badge">
      <img
        src="/assets/img/static-pages/medigi/v2-images/cities/austin-icon.svg"
        alt="austin"
      />
      <p class="city-name mb-0">Austin, TX</p>
    </div>
    <div class="city-badge">
      <img
        src="/assets/img/static-pages/medigi/v2-images/cities/asheville-icon.svg"
        alt="asheville"
      />
      <p class="city-name mb-0">Asheville, NC</p>
    </div>
  </div>
  <div class="three-badge-row">
    <div class="city-badge">
      <img
        src="/assets/img/static-pages/medigi/v2-images/cities/dallas-icon.svg"
        alt="dallas"
      />
      <p class="city-name mb-0">Dallas, TX</p>
    </div>
    <div class="city-badge">
      <img
        src="/assets/img/static-pages/medigi/v2-images/cities/fresno-icon.svg"
        alt="fresno"
      />
      <p class="city-name mb-0">Fresno, CA</p>
    </div>
    <div class="city-badge">
      <img
        src="/assets/img/static-pages/medigi/v2-images/cities/mexico-icon.svg"
        alt="mexico"
      />
      <p class="city-name mb-0">Mexico</p>
    </div>
  </div>
</div>
